const {
  REACT_APP_FS_CDN,
  REACT_APP_FS_WATERMARK,
  REACT_APP_FS_WATERMARK_NEW,
  REACT_APP_FS_WATERMARK_PENDING,
  REACT_APP_FS_WATERMARK_REMOVED,
  REACT_APP_FS_WATERMARK_SOLD,
  REACT_APP_FS_WATERMARK_SPECIAL,
  REACT_APP_FS_WATERMARK_WARRANTY_INCLUDED,
} = process.env;

/**
 * `FS_CDN` - Retrieves `REACT_APP_FS_CDN` from .env
 * @constant {string} fscdn
 * @default
 */
export const FS_CDN = REACT_APP_FS_CDN || "https://cdn.filestackcontent.com";

/**
 * `FS_WATERMARK` - Retrieves `REACT_APP_FS_WATERMARK` from .env
 * @constant {string} fswatermark
 * @default
 */
export const FS_WATERMARK = REACT_APP_FS_WATERMARK;

/**
 * `FS_WATERMARK_NEW` - Retrieves `REACT_APP_FS_WATERMARK_NEW` from .env
 * @constant {string} fswatermarknew
 * @default
 */
export const FS_WATERMARK_NEW = REACT_APP_FS_WATERMARK_NEW;

/**
 * `FS_WATERMARK_PENDING` - Retrieves `REACT_APP_FS_WATERMARK_PENDING` from .env
 * @constant {string} fswatermarkpending
 * @default
 */
export const FS_WATERMARK_PENDING = REACT_APP_FS_WATERMARK_PENDING;

/**
 * `FS_WATERMARK_REMOVED` - Retrieves `REACT_APP_FS_WATERMARK_REMOVED` from .env
 * @constant {string} fswatermarkremoved
 * @default
 */
export const FS_WATERMARK_REMOVED = REACT_APP_FS_WATERMARK_REMOVED;

/**
 * `FS_WATERMARK_SOLD` - Retrieves `REACT_APP_FS_WATERMARK_SOLD` from .env
 * @constant {string} fswatermarksold
 * @default
 */
export const FS_WATERMARK_SOLD = REACT_APP_FS_WATERMARK_SOLD;

/**
 * `FS_WATERMARK_SPECIAL` - Retrieves `REACT_APP_FS_WATERMARK_SPECIAL` from .env
 * @constant {string} fswatermarkspecial
 * @default
 */
export const FS_WATERMARK_SPECIAL = REACT_APP_FS_WATERMARK_SPECIAL;

/**
 * `FS_WATERMARK_WARRANTY_INCLUDED` - Retrieves `REACT_APP_FS_WATERMARK_WARRANTY_INCLUDED` from .env
 * @constant {string} fswatermarkwarrantyincluded
 * @default
 */
export const FS_WATERMARK_WARRANTY_INCLUDED =
  REACT_APP_FS_WATERMARK_WARRANTY_INCLUDED;
